
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'hash',
  base: 'https://oe.schoolpi.net/',
  routes: [{
    path: '/',
    component: () => import('@/views/index'),
    name: 'Main',
    redirect: '/',
    children: [
      {
        path: '/',
        component: () => import('@/views/web/home'),
        name: 'Home',
        meta: { title: '首页' }
      },
      {
        path: '/article',
        component: () => import('@/views/web/article/index'),
        name: 'Article',
        meta: { title: '文章详情' }
      },
      {
        path: '/lxwm',
        component: () => import('@/views/web/lxwm/index'),
        name: 'Lxwm',
        meta: { title: '联系我们' }
      },
      {
        path: '/search',
        component: () => import('@/views/web/search/index'),
        name: 'SearchResult',
        meta: { title: '搜索页面' }
      },
      {
        path: '/xxjj/xxgk',
        component: () => import('@/views/web/xxjj/xxgk/index'),
        name: 'Xxjj',
        meta: { title: '学校简介' }
      },
      {
        path: '/zszy',
        component: () => import('@/views/web/zszy/index'),
        name: 'Zszy',
        meta: { title: '院系专业' }
      },
      {
        path: '/zyjs/xyjj',
        component: () => import('@/views/web/zszy/xyjj/index'),
        name: 'Xyxq',
        meta: { title: '院系专业' }
      },
      {
        path: '/zszy/zyjj',
        component: () => import('@/views/web/zszy/zyjj/index'),
        name: 'Zyjj',
        meta: { title: '院系专业' }
      },
      {
        path: '/lnfs',
        component: () => import('@/views/web/lnfs/index'),
        name: 'Lnfs',
        meta: { title: '历年分数' }
      },
      {
        path: '/zsjh',
        component: () => import('@/views/web/zsjh/index'),
        name: 'Zsjh',
        meta: { title: '招生计划' }
      },
      {
        path: '/xyfg',
        component: () => import('@/views/web/tsnn/index'),
        name: 'Tsnn',
        meta: { title: '校园风光', id: 0 }
      },

      {
        path: '/zsxx/dtxx',
        component: () => import('@/views/web/zsxx/dtxx/index'),
        name: 'Dtxx',
        meta: { title: '招生简章' }
      },
      {
        path: '/zsxx/dzzl',
        component: () => import('@/views/web/zsxx/dzzl/index'),
        name: 'Dzzl',
        meta: { title: '校企合作' }
      },
      {
        path: '/zsxx/zsdt',
        component: () => import('@/views/web/zsxx/zsdt/index'),
        name: 'zsdt',
        meta: { title: '招生动态' }
      },
      {
        path: '/zsxx/single',
        component: () => import('@/views/web/zsxx/single/index'),
        name: 'single',
        meta: { title: '单招' }
      },
      {
        path: '/zsxx/counterpart',
        component: () => import('@/views/web/zsxx/counterpart/index'),
        name: 'counterpart',
        meta: { title: '对口' }
      },
      {
        path: '/zsxx/series',
        component: () => import('@/views/web/zsxx/series/index'),
        name: 'series',
        meta: { title: '统考' }
      },
      {
        path: '/yxxw',
        component: () => import('@/views/web/yxxw/index'),
        name: 'Yxxw',
        meta: { title: '招生简章' }
      },
      {
        path: '/xydt',
        component: () => import('@/views/web/xydt/index'),
        name: 'xydt',
        meta: { title: '校园动态' }
      },
      {
        path: '/jzzc',
        component: () => import('@/views/web/jzzc/index'),
        name: 'jzzc',
        meta: { title: '奖助政策' }
      },
      {
        path: '/work/jydt',
        component: () => import('@/views/web/work/jydt/index'),
        name: 'jydt',
        meta: { title: '就业动态' }
      },
      {
        path: '/work/jycy',
        component: () => import('@/views/web/work/jycy/index'),
        name: 'jycy',
        meta: { title: '就业创业' }
      },
      {
        path: '/campus',
        component: () => import('@/views/web/spnn/index'),
        name: 'campus',
        meta: { title: '多彩校园' }
      },
      {
        path: '/campus/details',
        component: () => import('@/views/web/spnn/spxq'),
        name: 'details',
        meta: { title: '视频详情' }
      },
      {
        path: '/xxjj/szll',
        component: () => import('@/views/web/xxjj/szll'),
        name: 'Szll',
        meta: { title: '名师风采' }
      },
      {
        path: '/xxjj/student',
        component: () => import('@/views/web/xxjj/student'),
        name: 'student',
        meta: { title: '学子风采' }
      },
      {
        path: '/xxjj/details',
        component: () => import('@/views/web/xxjj/szDetails'),
        name: 'szDetails',
        meta: { title: '详情' }
      }
    ]
  },
  {
    path: '/blank',
    name: '404',
    component: () => import('@/views/blank.vue')
  }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  let data = {}
  store.watch(state => {
    data = state.blankData
    if (to.path !== '/blank') {
      if (data.maintenance_open_status === 0) return next()
      else { next({ path: '/blank' }) }
    } else if (to.path === '/blank') {
      if (data.maintenance_open_status !== 0) return next()
      else { next({ path: '/' }) }
    }
  })
})
export default router
